import { WindowLocation } from '../../_common/client/window-location';
import { ClientComponentLogger } from '../../client-component-logger';

const logger = new ClientComponentLogger('ui-aggregator-redirect');

export function createStatusCodeErrorMessage(statusCode: number) {
    const url = WindowLocation.getHref();
    const variationId = getVariationIdFromUrl(url);
    const productId = getProductIdFromUrl(url);
    return `ui-aggregator-status-code: ${statusCode} on productId: ${productId} from variationId ${variationId}, url: ${url}`;
}

function getVariationIdFromUrl(url: string) {
    try {
        const urlObj = new URL(url);
        const variationId = urlObj.searchParams.get('variationId');

        if (!variationId) {
            logger.logError({
                type: 'GeneralError',
                message: 'Failed to extract variationId from URL',
                data: { url, reason: 'No variationId query parameter found' },
            });
        }

        return variationId;
    } catch (error) {
        logger.logError({
            type: 'GeneralError',
            message: 'Failed to parse URL for variationId extraction',
            error: error instanceof Error ? error : new Error(String(error)),
            data: { url },
        });
        return null;
    }
}

function getProductIdFromUrl(url: string) {
    try {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;

        /*                                                */
        const pMatch = pathname.match(/\/p\/([^/?]+)/);
        if (pMatch) {
            return pMatch[1];
        }

        /*                              */
        const dcsMatch = pathname.match(/\/dcs\/products\/([^/?]+)/);
        if (dcsMatch) {
            return dcsMatch[1];
        }

        logger.logError({
            type: 'GeneralError',
            message: 'Failed to extract productId from URL',
            data: { url, pathname, reason: 'No matching pattern found for /p/ or /dcs/products/' },
        });

        return null;
    } catch (error) {
        logger.logError({
            type: 'GeneralError',
            message: 'Failed to parse URL for productId extraction',
            error: error instanceof Error ? error : new Error(String(error)),
            data: { url },
        });
        return null;
    }
}

/**
 *
 *
 *
 */
export function redirectToPreviousVariation(variationId: string): void {
    const url = WindowLocation.getHref();
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.set('variationId', variationId);
        WindowLocation.setHref(urlObj.toString());
        WindowLocation.reload();
    } catch (error) {
        logger.logError({
            type: 'GeneralError',
            message: 'Failed to redirect to previous variation',
            error: error instanceof Error ? error : new Error(String(error)),
            data: { url, variationId },
        });
    }
}
